import { Translate } from "../helpers/global-functions";
import { Translator } from "./translator";

export class Link extends Translator{

    id:string
    image:any
    link:string
    titleEn:string
    titleKh:string
    descEn:string
    descKh:string

    constructor(){
        super();
    }

    get imageUrl():string{
        return this.image.fileUrl;
    }

    get title():string{
        return this.translate(this.titleEn,this.titleKh)
    }
    get description():string {
        return this.translate(this.descEn,this.descKh)
    }

}